import React from 'react';

const Privacy = () => {
  return (
    <div style={styles.container}>
      <div style={styles.languageSection}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.date}><strong>Effective Date: May 10, 2026</strong></p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. No Data Collection</h2>
          <p>
            The <strong>Credo Watch</strong> application respects your privacy. <strong>We do not collect, store, transmit, or share any of your personal information or health data on our external servers.</strong> All data generated or processed by the app remains strictly and locally on your personal device.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Apple HealthKit Data Usage</h2>
          <p>
            Our app integrates with Apple's HealthKit to provide its core functionalities. Regarding HealthKit data, we strictly adhere to the following policies:
          </p>
          <ul style={styles.list}>
            <li><strong>Local Processing Only:</strong> All HealthKit data (such as CPR data, heart rate, etc.) is processed and saved entirely on your device. We do not upload or collect this data to any external server.</li>
            <li><strong>No Third-Party Sharing:</strong> We absolutely do not sell, share, or disclose your HealthKit data to third parties for advertising, marketing, or any other commercial purposes.</li>
            <li><strong>Sole Purpose:</strong> HealthKit data is used exclusively to provide and improve the health and fitness functionalities within the app on your device.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Contact Us</h2>
          <p>If you have any questions or concerns about our privacy practices, please contact us at:</p>
          <ul style={styles.list}>
            <li>Email: credo@credo-ltd.com</li>
            <li>Website: https://credo-ltd.co.kr</li>
          </ul>
        </section>
      </div>

      <hr style={styles.divider} />

      <div style={styles.languageSection}>
        <h1 style={styles.title}>개인정보처리방침</h1>
        <p style={styles.date}><strong>시행일: 2026년 5월 10일</strong></p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. 개인정보 수집 안 함 (No Collection)</h2>
          <p>
            <strong>Credo Watch</strong> 앱은 사용자의 프라이버시를 가장 중요하게 생각합니다. <strong>본 앱은 사용자의 어떠한 개인정보나 건강 데이터도 당사의 외부 서버로 수집, 전송, 또는 저장하지 않습니다.</strong> 앱을 통해 생성되거나 처리된 모든 데이터는 오직 사용자의 기기 내부에만 안전하게 보관됩니다.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Apple HealthKit (건강 앱) 데이터 취급 방침</h2>
          <p>
            본 앱은 핵심 서비스 제공을 위해 Apple의 HealthKit 프레임워크와 연동하며, 다음의 원칙을 엄격히 준수합니다.
          </p>
          <ul style={styles.list}>
            <li><strong>로컬 처리 원칙:</strong> HealthKit을 통해 연동된 모든 데이터(CPR, 심박수 등)는 사용자 기기 내에서만 처리 및 저장되며, 어떠한 경우에도 당사의 서버로 전송되거나 수집되지 않습니다.</li>
            <li><strong>제3자 제공 금지:</strong> 당사는 HealthKit 데이터를 광고, 마케팅 또는 기타 상업적 목적으로 제3자에게 절대 판매하거나 공유하지 않습니다.</li>
            <li><strong>목적 제한:</strong> HealthKit 데이터는 오직 기기 내에서 사용자의 건강 및 피트니스 기능을 제공하기 위한 목적으로만 사용됩니다.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. 문의처</h2>
          <p>개인정보 보호 및 앱 사용과 관련된 문의 사항은 아래로 연락해 주시기 바랍니다.</p>
          <ul style={styles.list}>
            <li>이메일: credo@credo-ltd.com</li>
            <li>웹사이트: https://credo-ltd.co.kr</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    lineHeight: '1.6',
    color: '#333',
    backgroundColor: '#fff',
  },
  languageSection: {
    padding: '20px 0',
  },
  divider: {
    margin: '40px 0',
    border: '0',
    borderTop: '2px dashed #ccc',
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '10px',
    borderBottom: '2px solid #eaeaea',
    paddingBottom: '10px',
  },
  date: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '30px',
  },
  section: {
    marginBottom: '30px',
  },
  heading: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '15px',
    color: '#1a1a1a',
  },
  list: {
    marginTop: '10px',
    paddingLeft: '20px',
  }
};

export default Privacy;